import { render, staticRenderFns } from "./gaoxueya.vue?vue&type=template&id=1e74a338&scoped=true&"
import script from "./gaoxueya.vue?vue&type=script&lang=ts&"
export * from "./gaoxueya.vue?vue&type=script&lang=ts&"
import style0 from "./gaoxueya.vue?vue&type=style&index=0&id=1e74a338&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e74a338",
  null
  
)

export default component.exports